<template>
    <modal :id="modalId" title="History" ok-only ok-title="Close" ok-variant="secondary">
        <div class="mt-n4">
            <b-row class="align-items-center mt-4" v-for="(history, index) in histories" :key="history.id">
                <b-col cols="8" sm="9">
                    <div class="text-break font-weight-bold">{{ history.initiated_by }}</div>
                    <div>{{ getDate(history.created) }}</div>
                    <b-badge pill :variant="history.status === 'Published' ? 'success' : 'light'">{{
                        history.status
                    }}</b-badge>
                </b-col>
                <b-col cols="4" sm="3" class="d-flex justify-content-end">
                    <b-button variant="light" v-if="history.id == historyId" disabled> Viewing </b-button>
                    <b-button
                        @click="() => handleViewClick(history.id)"
                        variant="primary"
                        v-else
                        :disabled="index !== 0 && history.status === 'In Review'"
                    >
                        View
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </modal>
</template>

<script>
import { format, parseISO } from 'date-fns';
import Modal from '../generic/modal/modal.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'HistoryModal',
    components: {
        Modal,
    },
    props: {
        histories: Array,
        modalId: String,
    },
    computed: {
        ...mapGetters('header', ['userUnicodeDateFormat', 'userTimeFormat']),
        historyId() {
            return this.$route.query.history_id || this.histories[0]?.id;
        },
    },
    methods: {
        handleViewClick(historyId) {
            this.$router.push({ query: { history_id: historyId } });
            this.$bvModal.hide(this.modalId);
        },
        getDate(date) {
            return format(parseISO(date), `${this.userUnicodeDateFormat} ${this.userTimeFormat}`);
        },
    },
};
</script>
